import deNodify from '../deNodify';
import { sum, map } from '../nodash';

const countCartItems = (lineItems) => {
  return sum(map('quantity', deNodify(lineItems)));
};

export default countCartItems;
